<template >
  <q-card
      class="column full-height"
      :style="'padding:5px;width:'+( $mobileDevice?'100%':'70%;')" >
    <q-card-actions class="row items-end justify-end no-wrap" >

      <!--            <q-space />-->


      <q-btn
          flat
          round
          icon="close"
          @click="$emit('done')" />
    </q-card-actions >

    <el-row >
      <el-col :md="24" >
        <div style="width: 100%" >
          <h4 >Issue on date
            <q-btn
                :color="allowChangeDate? 'red' : 'deep-orange'"
                icon="edit_location"
                @click="allowChangeDate = !allowChangeDate" >{{ forceInvDate }}
            </q-btn >

          </h4 >
          <q-input
              filled
              v-if="allowChangeDate"
              v-model="forceInvDate"
              xmask="date"
              clearable
              xrules="['date']" >

            <template v-slot:append >
              <q-icon
                  name="event"
                  class="cursor-pointer" >
                <q-popup-proxy
                    ref="qDateProxy"
                    transition-show="scale"
                    transition-hide="scale" >
                  <q-date
                      v-model="forceInvDate"
                      mask="DD/MM/YYYY" >
                    <div class="row items-center justify-end" >
                      <q-btn
                          v-close-popup
                          label="Close"
                          color="primary"
                          flat />
                    </div >
                  </q-date >
                </q-popup-proxy >
              </q-icon >
            </template >
          </q-input >
        </div >
      </el-col >
      <el-col :md="12" >
        <!--        <div class="q-pa-md row items-start q-gutter-md" >-->
        <q-card
            flat
            bordered >

          <q-card-section class="column items-center no-wrap" >
            <h3 >Handle Bookings</h3 >
            <h4
                class="col-12"
                v-if="dbgInvoices.bookingsSums" >
              <small >Selected booking sums:</small >
              {{ $theMoney(dbgInvoices.bookingsSums) }}&euro;
            </h4 >
            <h4 v-if="dbgInvoices.newIssues" >

              {{ dbgInvoices.newIssues }}
              <small > new bookings</small >
              to be issued
            </h4 >
            <h4 v-if="dbgInvoices.newRefunds" >

              {{ dbgInvoices.newRefunds }}
              <small > new canceled tickets</small >
              to be refunded
            </h4 >
            <span v-if="dbgInvoices.mainNormalInvoiceLabel=='toomany'" >You have selected more than one different refund invoices.Not possible to handle mass refund</span >
            <template v-else >
                <span v-if="dbgInvoices.mainNormalInvoiceId" >!!!All selected bookings that have not be processed will be included in invoice {{
                    dbgInvoices.mainNormalInvoiceLabel
                                                              }}</span >
            </template >
            <div >
              Issue Selected as
              <el-radio-group v-model="invoiceKind" >
                <el-radio-button label="receipt" ></el-radio-button >

                <el-radio-button label="invoice" ></el-radio-button >
              </el-radio-group >
              , and will be isuued as
              <el-radio-group v-model="invoicedAs" >
                <el-radio-button label="onebyone" > seperated invoices</el-radio-button >

                <el-radio-button label="inone" > one invoice</el-radio-button >
              </el-radio-group >
            </div >
          </q-card-section >
          <div align="right" >
            <sf-button
                class="col-12 float-right"
                :disabled="!dbgInvoices.api_ids||!dbgInvoices.api_ids.length"

                @click="issueInvoices(false,false,true)"
                fit >Just print:{{ dbgInvoices.api_ids ? dbgInvoices.api_ids.length : '' }}
              <q-chip
                  dense
                  icon-right="directions"
                  v-if="workingKind == 'EXCRS'" >API
              </q-chip >
              <q-chip
                  dense
                  icon-right="arrow_right_alt"
                  v-else >Invoices
              </q-chip >
            </sf-button >
            <sf-button
                v-if="!processing&&!thereAreErrors"

                type="success"
                class="col-12 float-right"
                :disabled="!dbgInvoices.bookingsLength&&!dbgInvoices.newRefunds&&!dbgInvoices.newIssues"
                :confirm="allowChangeDate?'Are you sure you want to issue on date '+forceInvDate+'?':null"
                @click="issueInvoices()"
                fit >{{ submitMsg }}
              <q-chip
                  dense
                  icon-right="directions"
                  v-if="workingKind == 'EXCRS'" >API
              </q-chip >
              <q-chip
                  dense
                  icon-right="arrow_right_alt"
                  v-else >bookings on Invoice
              </q-chip >
            </sf-button >
            <template v-else >
              <el-row v-if="processing" >
                <el-col :md="8" >
                  <el-alert

                      :closable="false"
                      center >Processing {{ bookingsToSubmit.length + 1 }}
                  </el-alert >
                </el-col >
                <el-col :md="8" >
                  <el-alert
                      type="success"
                      :closable="false"
                      center
                      show-icon
                      v-if="succesForAADE.length" > Success {{ succesForAADE.length }}

                  </el-alert >
                </el-col >
                <el-col :md="8" >
                  <el-alert
                      v-if="retryBookings.length"
                      type="error"
                      :closable="false"
                      center >Problems {{ retryBookings.length }}
                  </el-alert >
                </el-col >


              </el-row >


              <sf-button
                  v-if="thereAreErrors&&!processing"
                  type="warning"
                  @click="issueWithAade()" >Lets retry to submit {{ retryBookings.length }}
              </sf-button >
            </template >

          </div >


        </q-card >
        <q-card >
          <el-alert
              v-if="dbgInvoices.checkTrip"
              style="width: 100%"
              type="warning"
              :title="dbgInvoices.checkTrip.title" >
            check it out if you want
            <el-button
                type="warning"
                icon="el-icon-top-right"
                @click="routeGo(dbgInvoices.checkTrip.click)" >{{ dbgInvoices.checkTrip.msg }}
            </el-button >
          </el-alert >
          <div
              style="width: 100%;border: 1px firebrick dashed"
              v-if="rawErrors " >
            <h4 >Errors</h4 >
            <pre >{{ rawErrors }}</pre >
          </div >
          <!--        ==={{succesForAADE}}-->
          <div
              v-for="reprt in submitReport"
              style="width: 100%;" >
            <el-button
                type="warning"
                v-if="reprt.bkId"
                @click="goToBooking(reprt.bkId)" >{{ reprt.msg }}
            </el-button >
            <el-alert
                v-else
                :title="reprt.msg"
                :type="reprt.type"
                show-icon ></el-alert >
          </div >
        </q-card >
      </el-col >
      <el-col :md="12" >
        <q-card
            flat
            bordered >

          <q-card-section class="column items-center no-wrap" >
            <h3 >Handle Mass Refunds</h3 >
            <div >

              <!--              <q-date-->
              <!--                  v-model="forceInvDate"-->
              <!--                  minimal-->
              <!--              />-->
              <label >Refund Group (Σειρά)</label >
              <el-input
                  xfilled
                  v-model="siraLeter"
                  label="Refund Group (Σειρά)" />
              <label >Override refund price</label >
              <el-input
                  xfilled
                  v-model="overrideRefundPrice"
                  label="Refund Group (Σειρά)" />
              <label >Refund line comment</label >
              <el-input
                  xfilled
                  v-model="overrideRefundDescription"
                  label="Refund Description" />

              <!--            </div >-->
              <!--            <div class="q-pa-md" style="max-width: 300px">-->

              <div
                  class="q-pa-md"
                  style="width: 100%;" >
                <!--                <textarea style="width: 100%;"-->
                <!--                    v-model="commentOnInvoice"-->
                <!--                   rows="3"-->
                <!--                />-->
              </div >
            </div >
            <!--          </q-card-section >-->

            <!--          <q-card-section class="row justify-end align-center flex-grow " >-->
            <h4
                class="col-12"
                v-if="dbgInvoices.refuntSum&&workingKind == 'EXCRS'" >
              <small >Selected refunds sums:</small >
              {{ $theMoney(dbgInvoices.refuntSum) }}&euro;
            </h4 >
            <!--              <p >{{ dateFromUnxTime(bestTimeToCheck) }}&#45;&#45;&#45;&#45;is&#45;&#45;{{ dateFromUnxTime(bestTimeToIssue) }}</p >-->
            <label >Comment on invoice</label >
            <textarea
                style="width: 100%;"
                v-model="commentOnInvoice"
                rows="3" />
            <!--{{dbgInvoices}}-->
            <span v-if="dbgInvoices.mainRefuntInvoiceLabel=='toomany'" >You have selected more than one issued invoices.Not possible to handle more than one invoices</span >
            <template v-else >
                <span v-if="dbgInvoices.mainRefuntId&&dbgInvoices.refuntLength >1" >!!!All selected bookings that have not be processed will be included in the invoice {{
                    dbgInvoices.mainRefuntInvoiceLabel
                                                                                    }}</span >
            </template >


            <!--            <sf-button-->
            <!--                class="col-12 float-right"-->
            <!--                :disabled="!dbgInvoices.api_ids.length"-->

            <!--                @click="issueInvoices(false,false,true)"-->
            <!--                fit >Just print:{{ dbgInvoices.api_ids.length }} Refunds-->
            <!--            </sf-button >-->


          </q-card-section >
          <q-card-actions align="right" >

            <!--            <q-space />-->

            <sf-button
                class="col-12 float-right"
                v-if="workingKind == 'EXCRS'"
                style="width: 100%"
                fit
                type="warning"
                @click="massActions('uncancel')"
                confirm="This action will keep all refunds in place but it will set tickets as normal.Are you sure?" >

              <span >Un-Cancel Selected</span >
            </sf-button >
            <sf-button
                fit
                class="col-12 float-right"
                v-if="workingKind == 'EXCRS'"
                style="width: 100%"
                :disabled="!dbgInvoices.refuntLength||dbgInvoices.mainRefuntInvoiceLabel=='toomany'"
                type="warning"
                @click="issueInvoices(true)"
                confirm="Are you sure?" >

              <span >Issue Refunds ({{ dbgInvoices.refuntLength }}) in one transaction Σειρά {{ siraLeter }}</span >
            </sf-button >

          </q-card-actions >

        </q-card >


      </el-col >
    </el-row >
  </q-card >
</template >
<script >
import SfButton from "../../Form/SfButton"
import {mapActions, mapGetters, mapMutations} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";
import {fetchList, getModxList} from "../../../api/resource";

let lastQueryParams = null
export default {
  name: 'invoiceManagerPanel',
  components: {SfButton},
  props: {

    workingKind: {}
  },
  data() {
    return {
      selectedBookings: null,
      bookingsToSubmit: [],
      rawErrors: null,
      processing: false,
      submitReport: [],
      allowChangeDate: false,
      forceInvDate: null,
      siraLeter: 'B',
      invoiceKind: null,
      invoicedAs: null,
      calckedTime: null,
      overrideRefundPrice: null,
      overrideRefundDescription: null,
      thereAreErrors: false,
      commentOnInvoice: null,
      succesForAADE: [],
      retryBookings: [],
      dbgInvoices: {
        issued_bkids: [],
        api_ids: [],
        checkTrip: null,
        mainRefuntInvoiceLabel: null,
        mainRefuntId: null,
        mainNormalInvoiceLabel: null,
        mainNormalInvoiceId: null,
        notOneInvoice: false,
        bookingsLength: null,
        bookingsSums: 0,
        refuntSum: 0,
        refuntLength: null,
        newRefunds: 0,
        newIssues: 0
      },
    }
  },
  computed: {
    ...mapGetters({
      getStore: "helpers/getStore",
      getStoreValues: "helpers/getStoreValues",
    }),
    bookingsQuery() {
      // var q = { ...this.$route.params, type: "full" }
      let q = {type: "full"};
      if (this.$route.params.fileid && this.$route.params.fileid != "all")
        q.fileid = this.$route.params.fileid;
      if (this.$route.params.tripid && this.$route.params.tripid != "all")
        q.tripid = this.$route.params.tripid;
      if (this.$route.params.fileid && this.$route.params.fileid != "all")
        q.fileid = this.$route.params.fileid;
      if (this.bookingRange) q.range = this.bookingRange;
      if (this.workingTripType) q.tripTypes = this.workingTripType;
      if (this.$route.query.query) {
        q.searching = true
        q.customerSearch = this.$route.query.query;
      }
      if (this.$route.query.invoice_status)
        q.invoice_status = this.$route.query.invoice_status;
      if (this.$route.query.booking_status)
        q.bookingStatus = this.$route.query.booking_status;
      if (this.$route.query.tourcoselect)
        q.tourcoselect = this.$route.query.tourcoselect;
      q.transferTypes = "all";

      q.type = "full";
      q.distributors = this.$route.query.distributor_select;
      return q;
    },
    submitMsg() {

      if (this.dbgInvoices.bookingsLength == this.succesForAADE.length)
        return 'All done nothing to submit'
      if ((this.succesForAADE.length && this.dbgInvoices.bookingsLength > this.succesForAADE.length) || this.thereAreErrors)
        return 'Try again to Issue ' + (this.dbgInvoices.bookingsLength - this.succesForAADE.length)
      if (!this.dbgInvoices.bookingsLength) return 'Done'
      return 'Issue ' + this.dbgInvoices.bookingsLength + (this.dbgInvoices.newIssues ? ' there are ' + this.dbgInvoices.newIssues + ' new ones ' : '') + (this.dbgInvoices.newRefunds ? '(For Refund ' + this.dbgInvoices.newRefunds + ')' : '')
    },
    bestTimeToIssue() {
      let calckedTime = 0
      const pendingMoves = this.selectedBookings;
      if (pendingMoves && pendingMoves.length) {

        pendingMoves.forEach((bk) => {
          if (bk && bk.id && bk.id != "") {
            calckedTime = calckedTime < bk.tripDateTime ? bk.tripDateTime : calckedTime
          }
        })
      }
      return calckedTime < this.unxnow() ? calckedTime : this.unxnow()
    },
    bestTimeToCheck() {
      let calckedTime = 0
      const pendingMoves = this.selectedBookings;
      if (pendingMoves && pendingMoves.length) {

        pendingMoves.forEach((bk) => {
          if (bk && bk.id && bk.id != "") {
            calckedTime = !calckedTime || calckedTime > bk.tripDateTime ? bk.tripDateTime : calckedTime
          }
        })
      }
      return calckedTime //> this.unxnow() ? calckedTime : this.unxnow()
    },
  },
  async mounted() {
    this.selectedBookings = this.getStoreValues("selectedBookings")
    if (!this.selectedBookings) {
      this.selectedBookings = await api.getModxList('vue_booking', this.bookingsQuery)
    }
    else if (this.selectedBookings[0].controller) {
      this.selectedBookings = await api.getModxList(this.selectedBookings[0].controller, {
        ...this.selectedBookings[0].queryParams, limit: 0
      })
    }
    _log_('selectedBookings', this.selectedBookings)
    await this.issueInvoices(false, true)
    await this.issueInvoices(true, true)
  },
  methods: {
    goToBooking(bkid) {
      if (!bkid) return
      this.$emit('done')
      let Q = this.$route.query;
      Q.bookingid = bkid;
      this.routeGo({
        name: this.$route.name + "Booking",
        params: Q,
      });
    },
    async issueWithAade(selectedBookings, queryParams, refundMode) {
      _log_('this. selectedBookings', this.retryBookings, selectedBookings)
      if (!selectedBookings) {
        selectedBookings = JSON.parse(JSON.stringify(this.retryBookings))

      }
      this.retryBookings = []
      this.succesForAADE = []
      this.submitReport = []

      if (!queryParams) queryParams = lastQueryParams
      else lastQueryParams = queryParams
      this.processing = true
      this.thereAreErrors = false
      this.dbgInvoices.bookingsLength = selectedBookings.length
      this.bookingsToSubmit = this.selectedBookings.filter(bk => selectedBookings.indexOf(bk.id) >= 0)
                                  .sort((a, b) => b.strip_time * 1 - a.strip_time * 1)
      _log_('this.bookingsToSubmit selectedBookings', this.bookingsToSubmit)
      // for (let i = 0; i < selectedBookings.length; i++) {
      //   const wBooking = this.bookingsToSubmit.pop(), bkId = wBooking.id;
      // _log_('wb,,,,',wBooking,(new Date(wBooking.strip_time*1000)))
      // }
      // return
      for (let i = 0; i < selectedBookings.length; i++) {
        const wBooking = this.bookingsToSubmit.pop(), bkId = wBooking.id;

        const sentParams = refundMode ? {...queryParams, refuntBkids: bkId, bkids: bkId} : {
          ...queryParams,
          // sort: 'tripDateTime',
          // dir: 'ASC',
          bkids: bkId
        };
        const {data} = await api.fetchProcessor("timologio/massissue", sentParams);
        _log_('issueWithAade', data)
        if (!data) {
          this.submitReport.push({
            type: 'error',
            msg: 'Problem with the server   '
          })
          return
        }
        if (data.results) {
          // if (data.results.invoices_nums)
          //   this.submitReport.push({
          //     type: 'success',
          //     msg: 'Issued invoice with number ' + data.results.invoices_nums.join(',')
          //   })
          if (data.results.aade_success) {
            this.succesForAADE.push(bkId)
            // data.results.success.forEach(invId => {
            //   const reprt = data.results.aade_success[invId]
            //
            //   this.submitReport.push({
            //     type: 'info',
            //     msg: 'success on submiting AADE '
            //   })
            // })
          }
          if (data.results.aade_errors) {
            this.thereAreErrors = true
            this.retryBookings.push(bkId)
            data.results.success.forEach(invId => {
              const err = data.results.aade_errors[invId]
              _log_('err,,,,', err)
              // if (err.fatal_error)
              if (err.results) {
                err.results.forEach(res => {
                  this.submitReport.push({
                    type: res.fatal_error ? 'error' : 'warning',
                    msg: 'AADE is not accesible due to  error   ' + (_.isString(err.errors) ? res.errors : res.errors.join(','))
                  })
                })
              }
              else
                this.submitReport.push({
                  type: err.fatal_error ? 'error' : 'warning',
                  msg: 'AADE is not accesible due to  error   ' + (_.isString(err.errors) ? err.errors : err.errors.join(','))
                })
            })
          }
        }

        if (!data.results.invoices[0]) {
          this.submitReport.push({
            bkId: bkId,
            type: 'warning',
            msg: 'Something is wrong with booking  id:' + bkId
          })
          // this.$notify({
          //   title: "Warning",
          //   message: "These trips must bre processed first",
          //   type: "warning",
          // });
          // return;
        }
        else {
          if (data.results.aade_success) this.$message({
            type: "success",
            message: Object.keys(data.results.aade_success).length + " sent successfully to TAX office"
          });
          if (data.results.aade_errors) this.$message({
            type: "warning",
            message: Object.keys(data.results.aade_errors).length + " were not accepted to TAX office"
          });
        }
      }
      this.processing = false
      // this.$emit('reload')

    },
    async massActions(action) {
      const pendingMoves = this.selectedBookings;
      let sentIds = []
      pendingMoves.forEach((bk) => {
        if (bk && bk.id && bk.id != "") sentIds.push(bk.id)
      })
      const data = await api.fetchProcessor("booking/fullupdate", {
        bookingids: sentIds.join(','),
        do: 'changeStatus',
        newStatus: 'normal',

      });
      ++this.clock;
    },
    async issueInvoices(massRefunds, initMode, onlyPrint) {
      const vmjs = this

      _log_("issueInvoices.dt.refunt_inv_timologioId..", this.workingKind, massRefunds, initMode, onlyPrint)
      // if (initMode) {
      // _log_("issueInvoices.dt.refunt_inv_timologioId..", this.dbgInvoices, selectedBookings);
      // this.forceInvDate=this.workingKind == "EXCRS"?this.formatUnxTime('now',false,true):calckedTime

      // this.allowChangeDate = false
      if (initMode)
        if (!massRefunds) {
          this.dbgInvoices.bookingsSums = 0
          this.dbgInvoices.mainNormalInvoiceLabel = null
          this.dbgInvoices.mainNormalInvoiceId = null
          this.dbgInvoices.newIssues = 0
          this.checkTrip = null
        }
        else {
          this.checkTrip = null
          // this.dbgInvoices.bookingsLength=0
          this.dbgInvoices.mainRefuntInvoiceLabel = null
          this.dbgInvoices.mainRefuntId = null
          this.dbgInvoices.newRefunds = 0
          this.dbgInvoices.refuntSum = 0
          this.dbgInvoices.refuntLength = 0
        }
      // if(initMode)  this.dbgInvoices.bookingsLength=0
      // }
      if (!this.allowChangeDate) this.forceInvDate = null
      if (!massRefunds) this.dbgInvoices.bookingsSums = 0
      else this.dbgInvoices.refuntSum = 0
      //  v-if="workingKind=='EXCRS'"
      this.errors = null;
      const oneDay = 3600 * 24, oneYear = 200 * oneDay, vm = this
      let calckedTime = this.bestTimeToIssue
      let selectedBookings = [],
          selectedBookingsForRefunt = [],
          inv_timologioId = null,
          problem = false;
      const pendingMoves = this.selectedBookings;

      if (this.workingKind == "EXCRS") {
        this.calckedTime = this.unxnow();

      }
      else {
        if (this.ScheduleTrip && this.ScheduleTrip.time)
          calckedTime = this.ScheduleTrip.time;
        else if (
            this.$route.query.timerange_from == this.$route.query.timerange_to
        )
          calckedTime = this.$route.query.timerange_from;
      }

      this.dbgInvoices.api_ids = []
      this.dbgInvoices.issued_bkids = []
      this.dbgInvoices.bookingsLength = 0
      // return;
      if (pendingMoves && pendingMoves.length) {
        // calckedTime = 0
        pendingMoves.forEach((bk) => {
          if (bk && bk.id && bk.id != "") {


            if (bk.invoiceinfo != 'block_api' && bk.bookedPrice) {
              if (massRefunds) {
                if (bk.refunt_inv_timologioId)
                  if (!this.dbgInvoices.mainRefuntId) {
                    this.dbgInvoices.mainRefuntId = bk.refunt_inv_timologioId;
                    this.dbgInvoices.mainRefuntInvoiceLabel = bk.refunt_inv_aa + ':' + this.formatUnxTime(bk.refunt_inv_date, false, true)
                  }
                  else if (this.dbgInvoices.mainRefuntId != bk.refunt_inv_timologioId)
                    this.dbgInvoices.mainRefuntInvoiceLabel = 'toomany'
                if (bk.inv_timologioId) {
                  this.dbgInvoices.refuntSum += bk.bookedPrice
                  selectedBookingsForRefunt.push(bk.id);
                  // ++this.dbgInvoices.bookingsLength
                }
              }
              else {
                if (this.workingKind != "EXCRS" && bk.inv_timologioId) {//restrict excrs from mass issuing
                  if (!this.dbgInvoices.mainNormalInvoiceId) {
                    this.dbgInvoices.mainNormalInvoiceId = bk.inv_timologioId;
                    this.dbgInvoices.mainNormalInvoiceLabel = bk.inv_aa + ':' + this.formatUnxTime(bk.inv_date, false, true)
                  }

                }
                if ((bk.execStatus != "canceled" && bk.status != "canceled")) {
                  this.dbgInvoices.bookingsSums += bk.bookedPrice
                  selectedBookings.push(bk.id);
                  if (initMode) {
                    ++this.dbgInvoices.bookingsLength
                    if (!bk.inv_timologioId && !massRefunds) {
                      ++this.dbgInvoices.newIssues
                      // ++this.dbgInvoices.bookingsLength
                    }
                  }
                }
                else if (!bk.refunt_inv_timologioId && bk.inv_timologioId) {
                  selectedBookingsForRefunt.push(bk.id);
                  // ++this.dbgInvoices.bookingsLength
                }
              }


              if (!bk.refunt_inv_timologioId && bk.inv_timologioId && bk.execStatus == "canceled") ++this.dbgInvoices.newRefunds

              if (bk.inv_timologioId) {
                if (this.dbgInvoices.api_ids.indexOf(bk.inv_timologioId) <= 0) this.dbgInvoices.api_ids.push(bk.inv_timologioId)
                this.dbgInvoices.issued_bkids.push(bk.id)
                if (initMode) ++this.dbgInvoices.bookingsLength
              }
            }
          }
        });

        let doWhat = this.invoicedAs ? this.invoicedAs : this.workingKind == "EXCRS" ? (massRefunds ? 'refunds' : "onebyone") : "inone";
        this.invoicedAs = doWhat
        this.invoiceKind = this.invoiceKind ? this.invoiceKind : (this.workingKind == "EXCRS" ? 'receipt' : 'invoice')
        // return
        if (onlyPrint) {
          if (massRefunds && this.dbgInvoices.api_ids.length)
            this.goPdf("refund-invoice-printer.html", {
              bkid: this.dbgInvoices.api_ids.join(","),
            }); else if (this.workingKind == "EXCRS" && this.dbgInvoices.issued_bkids.length)
            this.goPdf("voucher-printer-excrs.html", {
              bkid: this.dbgInvoices.issued_bkids.join(","),
            }); else if (this.workingKind != "EXCRS" && this.dbgInvoices.api_ids.length)
            this.goPdf("voucher-printer-transfers.html", {
              bkid: this.dbgInvoices.api_ids.join(","),
            });
          this.$emit('done')
          return
        }
        if (initMode) this.dbgInvoices.bookingsLength += this.dbgInvoices.newIssues
        if (!this.allowChangeDate) this.forceInvDate = isNaN(calckedTime) ? calckedTime : this.formatUnxTime(calckedTime, false, true)//this.forceInvDate = calckedTime
        if (initMode) {
          _log_("issueInvoices.dt.refunt_inv_timologioId..", selectedBookingsForRefunt, this.dbgInvoices, selectedBookings);
          // this.forceInvDate=this.workingKind == "EXCRS"?this.formatUnxTime('now',false,true):calckedTime

          if (!massRefunds) {
            this.bookingsSums = 0

            this.newIssues = 0
            // this.selectedBookings.forEach(e => sum += e.bookedPrice)

            // this.dbgInvoices.bookingsLength = selectedBookings.length
          }
          else this.dbgInvoices.refuntLength = selectedBookingsForRefunt.length
          return
        }

        // if (problem) {
        //   this.$message({
        //     message: 'Please select a trip first',
        //     type: 'warning'
        //   });
        //   return;
        // }

        if (this.workingKind == "EXCRS" && this.invoiceKind != 'invoice' && !massRefunds && this.dbgInvoices.newRefunds != this.dbgInvoices.newIssues) {
          _log_('check selectedBookings', this.workingKind, this.dbgInvoices, selectedBookings)
          const checkPastInvoices = await api.fetchProcessor("vue_booking/getlist", {
            tripTypes: 'EXCRS',
            type: 'full',
            dir: 'DESC',
            limit: 0,
            _id_notIn: selectedBookings,
            co_invoice_policy: this.invoiceKind,
            execStatus: 'notcanceled',
            range: [this.formatUnxTime(this.bestTimeToCheck - oneYear, false, true),
                    this.formatUnxTime(this.bestTimeToCheck - oneDay, false, true)],
            invoice_status: 'notissued',
          });
          if (checkPastInvoices.data.results && checkPastInvoices.data.results.length) {
            this.dbgInvoices.checkTrip = {
              click: {
                params: {
                  tripid: checkPastInvoices.data.results[0].strip_id
                },
                query: {
                  timerange_from: vm.formatUnxTime(checkPastInvoices.data.results[0].tripDateTime),
                  timerange_to: vm.formatUnxTime(checkPastInvoices.data.results[0].tripDateTime)
                }
              },
              title: "I cant issue invoices because there are bookings (" + checkPastInvoices.data.results.length + ') not issued',
              msg: vm.formatUnxTime(checkPastInvoices.data.results[0].tripDateTime) + ' ' + checkPastInvoices.data.results[0].tserv_title
            }
            // if(testMode){
            //   this.dbgIssue="I cant issue invoices because there are bookings (" + checkPastInvoices.data.results.length + ') not issued :'+ vm.formatUnxTime(checkPastInvoices.data.results[0].tripDateTime) + ' ' + checkPastInvoices.data.results[0].tserv_title
            //   return
            // }
            // this.$notify({
            //   title: "I cant issue invoices because there are bookings (" + checkPastInvoices.data.results.length + ') not issued ',
            //   message: vm.formatUnxTime(checkPastInvoices.data.results[0].tripDateTime) + ' ' + checkPastInvoices.data.results[0].tserv_title,
            //   type: "warning",
            //   duration: 45000,
            //   onClick() {
            //     vm.routeGo({
            //       params: {
            //         tripid: checkPastInvoices.data.results[0].strip_id
            //       },
            //       query: {
            //         timerange_from: vm.formatUnxTime(checkPastInvoices.data.results[0].tripDateTime),
            //         timerange_to: vm.formatUnxTime(checkPastInvoices.data.results[0].tripDateTime)
            //       }
            //     })
            //   }
            // });
            return
          }
        }
        if (!selectedBookings.length && !selectedBookingsForRefunt.length) {
          if (initMode)
            return 'Nothing to issue'
          this.$notify({
            title: "There is nothing to issue",
            message: 'Check your selection for 0 priced or no api tickets',
            type: "warning",
            duration: 45000
          });
          return
        }
        inv_timologioId = null;
        if (this.workingKind != "EXCRS" && !massRefunds) inv_timologioId = this.dbgInvoices.mainNormalInvoiceId

        if (massRefunds) inv_timologioId = this.dbgInvoices.mainRefuntId

        // doWhat='inone'
        _log_('about 1 isuuue', doWhat, onlyPrint)
        if (doWhat == "onebyone") {
          _log_('about isuuue go', doWhat, onlyPrint)
          await this.issueWithAade(selectedBookings, {
            do: doWhat,
            kind: this.invoiceKind,
            // issue_time: this.forceInvDate,
            sira: this.siraLeter,
            overrideRefundPrice: this.overrideRefundPrice,
            overrideRefundDescription: this.overrideRefundDescription,
            // bkids: selectedBookings.join(","),
            // refuntBkids: selectedBookingsForRefunt.join(","),
            mainInvoice: inv_timologioId,
            commentOnInvoice: this.commentOnInvoice,
            issue_time: this.allowChangeDate && this.forceInvDate ? this.forceInvDate : calckedTime,//this.workingKind == "EXCRS" ? this.unxnow() :
          })
          if (selectedBookingsForRefunt && selectedBookingsForRefunt.length) {
            await this.issueWithAade(selectedBookingsForRefunt, {
              do: doWhat,
              kind: this.invoiceKind,
              // issue_time: this.forceInvDate,
              sira: this.siraLeter,
              overrideRefundPrice: this.overrideRefundPrice,
              overrideRefundDescription: this.overrideRefundDescription,
              // bkids: selectedBookings.join(","),
              // refuntBkids: selectedBookingsForRefunt.join(","),
              mainInvoice: inv_timologioId,
              commentOnInvoice: this.commentOnInvoice,
              issue_time: this.allowChangeDate && this.forceInvDate ? this.forceInvDate : calckedTime,//this.workingKind == "EXCRS" ? this.unxnow() :
            }, true)
          }
          return
        }
        if (selectedBookings) selectedBookings = selectedBookings.sort((a, b) => a.strip_time * 1 - b.strip_time * 1)
        const {data} = await api.fetchProcessor("timologio/massissue", {
          do: doWhat,
          kind: this.invoiceKind,
          // issue_time: this.forceInvDate,
          sira: this.siraLeter,
          overrideRefundPrice: this.overrideRefundPrice,
          overrideRefundDescription: this.overrideRefundDescription,
          bkids: selectedBookings.join(","),
          refuntBkids: selectedBookingsForRefunt.join(","),
          mainInvoice: inv_timologioId,
          commentOnInvoice: this.commentOnInvoice,
          issue_time: this.allowChangeDate && this.forceInvDate ? this.forceInvDate : calckedTime,//this.workingKind == "EXCRS" ? this.unxnow() :
        });
        this.dbgInvoices = {
          mainRefuntInvoiceLabel: null,
          mainRefuntId: null,
          mainNormalInvoiceLabel: null,
          mainNormalInvoiceId: null,
          notOneInvoice: false,
          bookingsLength: null,
          bookingsSums: 0,
          refuntSum: 0,
          refuntLength: null,
          newRefunds: 0,
          newIssues: 0
        }
        ++this.clock;
        // _log_('isues.....',data)
        // this.selectedBookings = null;
        if (data && data.results) {
          if (data.results.errors && Object.values(data.results.errors).length) {
            this.$notify({
              title: "I cant issue invoices maybe some bookings since there are other bookings invoiced after this date",
              message: Object.values(data.results.errors)
                             .join(','),
              type: "warning",
              duration: 45000
            });
            return
          }
          // _log_('yelllpp', data.results)
          if (!data.results.invoices[0]) {
            this.$notify({
              title: "Warning",
              message: "These trips must bre processed first",
              type: "warning",
            });
            return;
          }
          else {
            if (data.results.aade_success) this.submitReport.push({
              type: "success",
              msg: Object.keys(data.results.aade_success).length + " sent successfully to TAX office"
            });
            if (data.results.aade_errors) this.submitReport.push({
              type: "warning",
              msg: Object.keys(data.results.aade_errors).length + " were not accepted to TAX office"
            });
          }

          if (massRefunds && data.results.invoices.length)
            this.goPdf("refund-invoice-printer.html", {
              bkid: data.results.invoices.join(","),
            }); else if (this.workingKind == "EXCRS" && data.results.invoices.length)
            this.goPdf("voucher-printer-excrs.html", {
              bkid: data.results.success.join(","),
            }); else if (this.workingKind != "EXCRS" && data.results.invoices.length)
            this.goPdf("voucher-printer-transfers.html", {
              bkid: data.results.invoices.join(","),
            });
          if (data.results.errors.length) {
            this.rawErrors = data.results.errors;
            // this.errorDialog = true;
          }
        }

      }
    },
  }
}
</script >
